import router from '@/router'

function initialState() {
  return {
    showIntro: false,
    introStation: [
      { tenantName: 'JDS', stationName: 'ED1' },
      { tenantName: 'SUNCOR DPL', stationName: 'Miwasin_ T1LI_MID' },
      { tenantName: 'Wapisiw', stationName: 'SW-WC' },
    ],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    start({ commit }) {
      commit('start')
    },
    end({ commit }) {
      commit('end')
    },
    gotoStation({ commit }, data) {
      commit('gotoStation', data)
    },
  },
  mutations: {
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    start: (state) => state.showIntro = true,
    end: (state) => state.showIntro = false,
    gotoStation: (state, data) => {
      let station
      state.introStation.forEach(x => {
        if (x.tenantName == data.tenantName) {
          station = x.stationName
        }
      })
      station = station ? station : data.firstStationName
      router.push('/stationdetail/' + station)
    },
  },

  getters: {
    'showIntro': (state) => state.showIntro,
    'introStation': (state) => state.introStation,
  },
}